/**
 * The string the average glyph advance is measured on. A fixed mixed-case sentence with word
 * spaces, so the capacity depends on the typography and the path alone and does not jump around as
 * the user types (a run of "i"s would otherwise promise room for twice as many characters).
 */
export const TEXT_ON_PATH_CAPACITY_SAMPLE_TEXT = 'The quick brown fox jumps over the lazy dog '

/** Advance of one glyph as a fraction of the font size when canvas measurement is unavailable. */
export const TEXT_ON_PATH_FALLBACK_ADVANCE_RATIO = 0.55

/** Smallest per-character step, in pt. Keeps heavy negative tracking from dividing by ~0. */
export const TEXT_ON_PATH_MIN_STEP_PT = 0.1

/** Upper bound on the counter's second number, so extreme tracking cannot show a huge figure. */
export const TEXT_ON_PATH_MAX_CAPACITY = 9999
